import {Component, Input, OnInit} from '@angular/core';
import {AppointmentTypeEnum} from '../../models/appointment';
import {IAddress} from '../../interfaces/address/address.interface';

@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: ['./appointment-details.component.scss']
})
export class AppointmentDetailsComponent implements OnInit {

  @Input() appointmentType: AppointmentTypeEnum;
  @Input() expertName: string;
  @Input() expertSpeciality: string;
  @Input() date: string;
  @Input() hourFrom: string;
  @Input() hourTo: string;
  @Input() duration: number;
  @Input() location?: IAddress | null | undefined;
  @Input() url: string;
  @Input() note: string;
  @Input() cardStyles: {};
  @Input() branchName: string;
  @Input() totalAppointmentsInService: number;
  @Input() visibleTotalAppointmentsInService = true;

  @Input() setNewDivAndWhiteBackground: boolean;

  appointmentTypeEnum = AppointmentTypeEnum;
  constructor() { }

  ngOnInit(): void {
  }

  /**
   * abre la url en una nueva pestaña.
   */
  onGotoUrl(): void {
    if (!this.url) return;
    window.open(this.url, '_blank');
  }
}
